import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useViewerIsSuperAdmin } from "@/lib/rights/use-viewer-is-baback-team";
import { ProductRecommendationsView } from "@/shared-screens/product-recommendations/product-recommendations-view";
import { Badge } from "@babackapp/ui/components/badge";
import { Navigate } from "react-router-dom";

/** Returns: the product recommendations tool, tester on the current shop. */
export default function ProductRecommendationsPage() {
  const { data: shop } = useCurrentShopSuspense();
  const isSuperAdmin = useViewerIsSuperAdmin();

  if (!isSuperAdmin) {
    return <Navigate to={`/shops/${shop.id}`} replace />;
  }

  return (
    <div className="flex items-center justify-center">
      <div className="w-full max-w-[1600px] lg:px-16 lg:py-6 px-6 py-4 space-y-4">
        <div className="mb-2 space-y-1">
          <div className="flex items-center gap-2">
            <h2 className="text-2xl leading-6 font-semibold text-foreground">
              Recommendations produit
            </h2>
            <Badge variant="outline" className="text-xs font-normal">
              @baback.co interne
            </Badge>
          </div>
          <p className="text-sm leading-relaxed text-muted-foreground max-w-[640px]">
            Outil de test pour l'algorithme de recommendations basé sur les
            co-occurrences de produits dans les commandes (Lift + Jaccard).
          </p>
        </div>
        <ProductRecommendationsView defaultShopId={shop.id} />
      </div>
    </div>
  );
}
